import { Autocomplete, Chip, TextField } from "@mui/material"
import { isNil } from "lodash"
import { useState } from "react"
import Wallet from "../../core/assets/oot/classic/OoT_Adult_s_Wallet_Icon.png"
import BottlePigPoe from "../../core/assets/oot/classic/OoT_Big_Poe_Soul_Icon.png"
import BlueFireI from "../../core/assets/oot/classic/OoT_Blue_Fire_Icon.png"
import BombBagI from "../../core/assets/oot/classic/OoT_Bomb_Bag_Model.png"
import BombchusI from "../../core/assets/oot/classic/OoT_Bombchu_Icon.png"
import BoomrangI from "../../core/assets/oot/classic/OoT_Boomerang_Icon.png"
import BossKeyI from "../../core/assets/oot/classic/OoT_Boss_Key_Model.png"
import BottleI from "../../core/assets/oot/classic/OoT_Bottle_Icon.png"
import ClaimCheckI from "../../core/assets/oot/classic/OoT_Claim_Check_Icon.png"
import DekuShieldI from "../../core/assets/oot/classic/OoT_Deku_Shield_Icon.png"
import DinsFireI from "../../core/assets/oot/classic/OoT_Din's_Fire_Icon.png"
import FrogI from "../../core/assets/oot/classic/OoT_Eyeball_Frog_Icon.png"
import BowI from "../../core/assets/oot/classic/OoT_Fairy_Bow_Icon.png"
import OcarinaI from "../../core/assets/oot/classic/OoT_Fairy_Ocarina_Icon.png"
import SlingshotI from "../../core/assets/oot/classic/OoT_Fairy_Slingshot_Icon.png"
import FaroreWindI from "../../core/assets/oot/classic/OoT_Farore's_Wind_Icon.png"
import FireArrowI from "../../core/assets/oot/classic/OoT_Fire_Arrow_Icon.png"
import GerudoCardI from "../../core/assets/oot/classic/OoT_Gerudo_Token_Icon.png"
import BiggoronSwordI from "../../core/assets/oot/classic/OoT_Giant's_Knife_Icon.png"
import GoronTunicI from "../../core/assets/oot/classic/OoT_Goron_Tunic_Icon.png"
import StrengthI from "../../core/assets/oot/classic/OoT_Goron_s_Bracelet_Icon.png"
import StrengthI2 from "../../core/assets/oot/classic/OoT_Silver_Gauntlets_Icon.png"
import StrengthI3 from "../../core/assets/oot/classic/OoT_Golden_Gauntlets_Icon.png"
import HookshotI from "../../core/assets/oot/classic/OoT_Hookshot_Icon.png"
import LongshotI from "../../core/assets/oot/classic/OoT_Longshot_Icon.png"
import HoverBootsI from "../../core/assets/oot/classic/OoT_Hover_Boots_Icon.png"
import HylianShieldI from "../../core/assets/oot/classic/OoT_Hylian_Shield_Icon.png"
import IceArrowI from "../../core/assets/oot/classic/OoT_Ice_Arrow_Icon.png"
import IronBootsI from "../../core/assets/oot/classic/OoT_Iron_Boots_Icon.png"
import KokiriSwordI from "../../core/assets/oot/classic/OoT_Kokiri_Sword_Icon.png"
import RutoLetterI from "../../core/assets/oot/classic/OoT_Letter_Icon.png"
import MagicMeterI from "../../core/assets/oot/classic/OoT_Magic_Jar_Model.png"
import HammerI from "../../core/assets/oot/classic/OoT_Megaton_Hammer_Icon.png"
import MirrorShieldI from "../../core/assets/oot/classic/OoT_Mirror_Shield_Icon.png"
import Prescription from "../../core/assets/oot/classic/OoT_Prescription_Icon.png"
import Scale from "../../core/assets/oot/classic/OoT_Silver_Scale_Icon.png"
import SmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model.png"
import WeirdEgg from "../../core/assets/oot/classic/OoT_Weird_Egg_Icon.png"
import Eyedrop from "../../core/assets/oot/classic/OoT_World_s_Finest_Eye_Drops_Icon.png"
import ZoraTunic from "../../core/assets/oot/classic/OoT_Zora_Tunic_Icon.png"
import Deadge from "../../core/assets/oot/classic/deadge.png"
import Bolero from "../../core/assets/oot/song/bolero.png"
import EponaSong from "../../core/assets/oot/song/epona.png"
import Minuet from "../../core/assets/oot/song/minuet.png"
import Nocturne from "../../core/assets/oot/song/nocturne.png"
import Prelude from "../../core/assets/oot/song/prelude.png"
import Requiem from "../../core/assets/oot/song/requiem.png"
import SariaSong from "../../core/assets/oot/song/saria.png"
import Serenade from "../../core/assets/oot/song/serenade.png"
import StormSong from "../../core/assets/oot/song/storm.png"
import SunSong from "../../core/assets/oot/song/sun.png"
import SongOfTime from "../../core/assets/oot/song/time.png"
import ZeldaLullaby from "../../core/assets/oot/song/zelda-lullaby.png"
import { ItemLightDto } from "../../core/items/ItemDataTypes"
export interface OotItemDto {
    name: string,
    tags?: Array<string>,
    img: string,
    childImage?: string,
    childName?: string,
    altString?: string,
    lightItem?: ItemLightDto
}

export const BombBag: OotItemDto = { name: "Bomb Bag", tags: ["BB"], img: BombBagI };

export const Bow: OotItemDto =   {name: "Bow", tags: ["Arc"], img: BowI }

export const Slingshot: OotItemDto = { name: "Slingshot", tags: ["Lance", "Pierre"], img: SlingshotI };
export const Ocarina: OotItemDto = { name: "Ocarina", tags: [], img: OcarinaI };
export const HookShot: OotItemDto = { name: "Hookshot", tags: [], img: HookshotI };
export const LongShot: OotItemDto = { name: "Longshot", tags: [], img: LongshotI };
export const MegatonHammer: OotItemDto = { name: "Megaton Hammer", tags: [], img: HammerI };
export const DinsFire: OotItemDto = { name: "Din's Fire", tags: ["Feu"], img: DinsFireI };
export const Strength1: OotItemDto = { name: "Strength 1", tags: ["Force"], img: StrengthI};
export const Strength2: OotItemDto = { name: "Strength 2", tags: ["Force"], img: StrengthI2};
export const Strength3: OotItemDto = { name: "Strength 3", tags: ["Force"], img: StrengthI3};
export const IronBoots: OotItemDto = { name: "Iron Boots", tags: ["Botte"], img: IronBootsI };
export const HoverBoots: OotItemDto = { name: "Hover Boots", tags: ["Botte"], img: HoverBootsI };
export const ZoraScale: OotItemDto =    { name: "Scale", tags: ["Ecaille", "Zora"], img: Scale };
export const Sos: OotItemDto =   { name: "Song of Storm", tags: ["Song"], img: StormSong };
export const ZL: OotItemDto =  { name: "Zelda Lullaby's", tags: ["Song", "Berceuse"], img: ZeldaLullaby }
export const Boomrang: OotItemDto =  { name: "Boomrang", tags: [], img: BoomrangI }
export const OotItems: Array<OotItemDto> = [
    { name: "Deadge", tags: ["dead", "sold out", "nothing", "rien"], img: Deadge },
    BombBag,
    Bow,
    Slingshot,
    Ocarina,
    { name: "Bombchus", tags: [], img: BombchusI },
    HookShot,

    MegatonHammer,
    { name: "Fire Arrow", tags: [], img: FireArrowI },
    { name: "Ice Arrow", tags: ["Blue Arrow"], img: IceArrowI },
    DinsFire,
    { name: "Farore's Wind", tags: ["Feu"], img: FaroreWindI },
    { name: "Ruto's Letter", tags: ["Lettre"], img: RutoLetterI },
    { name: "Bottle", tags: ["Bouteille"], img: BottleI },
    { name: "Blue Fire", tags: ["Bouteille"], img: BlueFireI },
    { name: "Big Poe", tags: ["Bouteille", "Bottle"], img: BottlePigPoe },
    { name: "Prescription", tags: [], img: Prescription },
    { name: "Eyeball Frog", tags: ["Grenouille"], img: FrogI },
    { name: "Eyedrop", tags: ["World", "Finest", "Goutte"], img: Eyedrop },
    { name: "Claim Check", tags: [], img: ClaimCheckI },
    { name: "Weird Egg", tags: ["Oeuf", "Bizarre"], img: WeirdEgg },
    { name: "Kokiri Sword", tags: ["KS"], img: KokiriSwordI },
    { name: "Biggoron Sword", tags: ["BGS"], img: BiggoronSwordI },
    { name: "Deku Shield", tags: ["Key"], img: DekuShieldI },
    { name: "Hylian Shield", tags: ["Key"], img: HylianShieldI },
    { name: "Mirror Shield", tags: ["MS"], img: MirrorShieldI },
    { name: "Magic Meter", tags: ["Magie"], img: MagicMeterI },
    { name: "Wallet", tags: ["Bourse"], img: Wallet },
    { name: "Gerudo's Card", tags: ["Token"], img: GerudoCardI },
    { name: "Goron Tunic", tags: [], img: GoronTunicI },
    { name: "Zora Tunic", tags: [], img: ZoraTunic },
    { name: "Scale Upgrade", tags: ["Ecaille", "Zora"], img: Scale },
    { name: "Strength Upgrade", tags: ["Force"], img: StrengthI},
    { name: "Iron Boots", tags: ["Botte"], img: IronBootsI },
    { name: "Hover Boots", tags: ["Botte"], img: HoverBootsI },
    { name: "Zelda Lullaby's", tags: ["Song", "Berceuse"], img: ZeldaLullaby },
    { name: "Saria's Song", tags: ["Song"], img: SariaSong },
    { name: "Epona's Song", tags: ["Song"], img: EponaSong },
    { name: "Sun's Song", tags: ["Song"], img: SunSong },
    { name: "Song of Time", tags: ["Song"], img: SongOfTime },
    { name: "Song of Storm", tags: ["Song"], img: StormSong },
    { name: "Prelude of Light", tags: ["Song"], img: Prelude },
    { name: "Minuet of Forest", tags: ["Song"], img: Minuet },
    { name: "Bolero of Fire", tags: ["Song"], img: Bolero },
    { name: "Serenade of Water", tags: ["Song"], img: Serenade },
    { name: "Nocturne of Shadow", tags: ["Song"], img: Nocturne },
    { name: "Requiem of Spirit", tags: ["Song"], img: Requiem },
    { name: "Small Key", tags: ["Key"], img: SmallKey },
    { name: "Boss Key", tags: ["Key"], img: BossKeyI },

]

interface OotItemAutocompleteProps {
    additionnalChange?: (val: OotItemDto) => void
    width?: string
}

const OotItemAutocomplete = (param: OotItemAutocompleteProps) => {

    let [item, setItem] = useState<OotItemDto | null>(null)

    if (!isNil(item))
        return <img src={item?.img} alt={item?.name} width={"30px"} height={"30px"} onContextMenu={() => setItem(null)} />

    return <Autocomplete
        options={OotItems}
        renderInput={(props) => <TextField
            {...props}
            label="Item"
            size='small'
            sx={{ width: param.width ?? "200px" }}

        />}
        renderTags={(values) =>
            values.map((value) => (
                <Chip
                    label={value.name}
                    icon={<img src={value.img} alt={value.name} height={20} width={20} />}
                />
            ))
        }
        renderOption={(props, option, state) => {
            return (
                <li {...props}>
                    <img src={option.img} alt={option.name} height={20} width={20} />
                    {option.name}
                </li>
            )
        }}
        onChange={(e, v) => {
            setItem(v);
        }}
        value={item}
        getOptionLabel={(o) => o.name}
        filterOptions={(o, v) => o.filter(x => x.name.toLowerCase().includes(v.inputValue.toLowerCase()) || x.tags?.some(t => t.toLowerCase().includes(v.inputValue.toLowerCase())))}
        size='small'
    />
}

export default OotItemAutocomplete